import script from "./ProjectHeaderRouting.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectHeaderRouting.vue?vue&type=script&setup=true&lang=js"

import "./ProjectHeaderRouting.vue?vue&type=style&index=0&id=9a440504&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a440504"]])

export default __exports__